import { useContext, memo, useEffect, useState } from "react";
import {
  Text,
  Box,
  Flex,
  ActionIcon,
  useMantineTheme,
  Loader,
} from "@mantine/core";
import { CatalogContext } from "src/api/context/CatalogContext";
import { calculateMinMax } from "../../ProductCatalogListing";
import { AppContext } from "src/api/AppContext";
import { useGetProductGroupPageDetailLazyQuery } from "src/generated/graphql";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const count = 4;
function ProductCatalogDetail() {
  const theme = useMantineTheme();
  const { currentLocation } = useContext(AppContext);
  const { setSelectedPG, sortRevenue, search, selectedPG } =
    useContext(CatalogContext);
  const [currentPage, setCurrentPage] = useState(1);

  const [getProductGroup, { data, loading }] =
    useGetProductGroupPageDetailLazyQuery({
      fetchPolicy: "network-only",
    });

  useEffect(() => {
    currentLocation && getMatchingProductGroup();
  }, [currentLocation, currentPage]);

  const getMatchingProductGroup = () => {
    getProductGroup({
      variables: {
        locationId: currentLocation?.id,
        getByProductsCount: true,
        pagination: {
          filters: [
            {
              field: "id",
              type: "text",
              value: sortRevenue,
              parentRelationField: "revenueCategory",
            },
            { field: "name", type: "text", value: search },
            { field: "filterGroup", type: "custom", value: selectedPG!.id },
          ],
          count,
          page: currentPage,
        },
      },
    });
  };

  return (
    <>
      {!!(loading || data?.productGroupPage?.items.length) && (
        <Text
          mt={"lg"}
          sx={{
            borderBottom: `1px solid #DDDDDD`,
            borderTop: `1px solid #DDDDDD`,
          }}
          size={20}
        >
          Related Items
        </Text>
      )}

      {!!data?.productGroupPage?.items.length && (
        <Flex align={"center"} justify={"center"} gap={"lg"}>
          <ActionIcon
            onClick={() => setCurrentPage(() => currentPage - 1)}
            size={"lg"}
            disabled={currentPage === 1}
          >
            <IoIosArrowBack size={27} color={theme.colors.gray[3]} />
          </ActionIcon>

          <Flex
            gap={"sm"}
            mt={"md"}
            align={"center"}
            justify={"center"}
            wrap={"wrap"}
          >
            {data?.productGroupPage?.items?.map((group) => (
              <Flex
                key={group.id}
                sx={(theme) => ({
                  height: 220,
                  width: 180,
                  border: `2px solid ${theme.colors.gray[1]}`,
                  borderRadius: 2,
                  position: "relative",
                })}
                align={"center"}
                justify={"center"}
                direction={"column"}
                onClick={() => setSelectedPG(group)}
              >
                <Box
                  sx={(theme) => ({
                    height: 120,
                    width: 120,
                    background: theme.colors.gray[1],
                  })}
                >
                  {group.imgUrl && (
                    <img
                      src={group.imgUrl || ""}
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                      }}
                      alt="Product Image"
                    />
                  )}
                </Box>

                <Text
                  sx={{
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    width: "inherit",
                    textAlign: "center",
                    lineHeight: 1,
                    paddingTop: 2,
                  }}
                >
                  {group.name}
                </Text>

                {calculateMinMax(group.products)}
              </Flex>
            ))}
          </Flex>

          <ActionIcon
            onClick={() => setCurrentPage(() => currentPage + 1)}
            size={"lg"}
            disabled={
              !data?.productGroupPage?.totalRows ||
              Math.ceil(data?.productGroupPage?.totalRows / count) ===
                currentPage
            }
          >
            <IoIosArrowForward color={theme.colors.gray[3]} size={27} />
          </ActionIcon>
        </Flex>
      )}

      {loading && (
        <Flex
          justify={"center"}
          align={"center"}
          sx={{
            height: 220,
            width: "100%",
          }}
        >
          <Loader size={"xl"} />
        </Flex>
      )}
    </>
  );
}

export default memo(ProductCatalogDetail);
